import {
  AssetData,
  PCDAssetData,
  AudioAssetData
} from '@experiment-management-shared/types';

export const transformAssetDataToPCDAsset = (
  asset: AssetData
): PCDAssetData => {
  const boxes = asset.items.find(item => item.assetItemType === 'boxes')
    ?.assetItemLink;
  const points = asset.items.find(item => item.assetItemType === 'points')
    ?.assetItemLink;

  return {
    boxes,
    experimentKey: asset.experimentKey,
    id: asset.assetId,
    metadata: asset.metadata || null,
    name: asset.userFileName,
    points,
    thumbnailPath: asset.thumbnailLink,
    step: asset.step,
    type: asset.assetType,
    path: asset.path
  };
};

export const transformAssetDataToAudioAsset = (
  asset: AssetData
): AudioAssetData => {
  return {
    experimentKey: asset.experimentKey,
    id: asset.assetId,
    metadata: asset.metadata || null,
    name: asset.userFileName,
    thumbnailPath: asset.thumbnailLink,
    step: asset.step,
    type: asset.assetType,
    path: asset.path,
    userFileName: asset.thumbnailLink
  };
};

export const sortAudioAssets = (
  assets: AudioAssetData[],
  assetNames: string[],
  experiments: string[]
): AudioAssetData[] => {
  const assetNamePriority = new Map(
    assetNames.map((name, index) => [name, index])
  );
  const experimentPriority = new Map(
    experiments.map((exp, index) => [exp, index])
  );

  return [...assets].sort((a, b) => {
    const namePriorityA = assetNamePriority.get(a.name) ?? Number.MAX_VALUE;
    const namePriorityB = assetNamePriority.get(b.name) ?? Number.MAX_VALUE;

    if (namePriorityA !== namePriorityB) {
      return namePriorityA - namePriorityB;
    }

    const experimentPriorityA =
      experimentPriority.get(a.experimentKey) ?? Number.MAX_VALUE;
    const experimentPriorityB =
      experimentPriority.get(b.experimentKey) ?? Number.MAX_VALUE;

    return experimentPriorityA - experimentPriorityB;
  });
};
